import React from "react";
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

import { useTranslation } from 'react-i18next';

import TitleCase from "components/formatting/TitleCase";
import { defaultSettings, PercentChangeSettingsStateType } from "./PercentChangeSettings";
import { toISOPercent } from "components/formatting/ISOPercentage";
import FittedText from "components/formatting/FittedText";

interface PercentChangePreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
    settingsState: PercentChangeSettingsStateType | {};
}

export default function PercentChangePreview(props: PercentChangePreviewProps) {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const windowHeight = window.innerHeight;
  const currentState = {...defaultSettings, ...props.settingsState};
  const percentValue = `↑${toISOPercent(i18n, .75)}`;

  return (
    <Stack
      sx={{
        gap: 1,
        width: isSmallScreen ? "100%" : "50%",
        flex: 1,
        height: windowHeight < 600 ? "35vh" : "55vh",
        position: "relative"
      }}>
      {currentState.widgetTitle !== 'none' &&
        <Typography
          sx={{ fontSize: "1.2rem", textAlign: currentState.widgetTitleAlignment }}
          variant="subtitle2">
          <TitleCase text={currentState.widgetTitle} />
        </Typography>}
      <FittedText content={percentValue} color={theme.colors.namedColors.positive} horizontalAlignment="center" />
    </Stack>
  );

}